import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef, MatDialogState } from '@angular/material/dialog';
import { AnalysisBoardComponent } from './analysisBoard.component';
import { IService } from '../asp/interfaces';
import * as settings from '../common/settings';
import { skip } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class AnalysisBoardService implements IService {
  private dialogRef: MatDialogRef<any>;

  constructor(private dialog: MatDialog) {
  }

  showWindow() {
    if (this.dialogRef && this.dialogRef.getState() == MatDialogState.OPEN) {
      let errorComp = this.dialogRef.componentInstance as AnalysisBoardComponent;
      errorComp.dialogRaise();
    }
    else {
      this.dialogRef = this.dialog.open(AnalysisBoardComponent, AnalysisBoardComponent.createDialogConfig());
      let errorComp = this.dialogRef.componentInstance as AnalysisBoardComponent;
      errorComp.dialogRaise();
    }
  }
}
